import { defineComponent as _defineComponent } from 'vue'
import ListArticle from '@/features/editorial/components/article/list/ListArticle.vue';
import EditorialArticle from '@/features/editorial/pages/EditorialArticle.vue';
import InfiniteScroll from '@/components/list/InfiniteScroll.vue';
import AppFooter from '@/components/footer/AppFooter.vue';

import { useListArticle } from '@/features/editorial/composables/useListArticle';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideArticle',
  setup(__props) {

const { article, isAtEndOfList, isLoadingArticles, onLoadNext } = useListArticle();

return { __sfc: true,article, isAtEndOfList, isLoadingArticles, onLoadNext, ListArticle, EditorialArticle, InfiniteScroll, AppFooter }
}

})